<ion-header class="ion-no-border">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-back-button mode="md" (click)="close()"></ion-back-button>
    </ion-buttons>
    <ion-title>Ticketart</ion-title>
    <ion-buttons slot="end" *ngIf="isEditMode">
      <ion-button slot="icon-only" style="box-shadow: none" (click)="edit(true)">
        <ion-icon name="fa-plus"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content NoScrollbar ArrowKeyUseable [arrowKeysOptions]="arrowKeysOptions"  class="ion-padding" [ngClass]="{'dark': (darkmode.isDarkMode | async), 'light': !(darkmode.isDarkMode | async)}">

  <div class="search">
    <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="search" class="search-icon svg-inline--fa fa-search fa-w-16" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="#B2B2B2" d="M505 442.7L405.3 343c-4.5-4.5-10.6-7-17-7H372c27.6-35.3 44-79.7 44-128C416 93.1 322.9 0 208 0S0 93.1 0 208s93.1 208 208 208c48.3 0 92.7-16.4 128-44v16.3c0 6.4 2.5 12.5 7 17l99.7 99.7c9.4 9.4 24.6 9.4 33.9 0l28.3-28.3c9.4-9.4 9.4-24.6.1-34zM208 336c-70.7 0-128-57.2-128-128 0-70.7 57.2-128 128-128 70.7 0 128 57.2 128 128 0 70.7-57.2 128-128 128z"></path></svg>
    <input #search type="search" [(ngModel)]="ticketEditSrv.ticketArtSearchText" class="search-input" placeholder="Bezeichnung..." (keydown.arrowup)="(false)" (keydown.arrowdown)="(false)" (keydown)="resetSelectedItem($event)"/>
  </div>

  <div class="TreeView" *ngFor="let tSearch of (ticketEditSrv.ticketArts | TreeViewSearch: ticketEditSrv.ticketArtSearchText); let i = index">
    <ion-item *ngIf="ticketEditSrv.ticketArtSearchText != ''" class="treeview-item" (mouseenter)="arrowKeysOptions.mouseOverItem.next(i)" (mousemove)="arrowKeysOptions.mouseMove.next(true)">
      <div class="heading"  (click)="artClicked(tSearch)">
        <h3>{{tSearch.description}}</h3>
        <p *ngIf="tSearch.interval">Interval: {{tSearch.interval}}</p>
        <p *ngIf="tSearch?.toCalculate >= 0">Berechnen: {{tSearch.toCalculate | ToCalculateNameById}}</p>
      </div>
    </ion-item>
  </div>


  <!-- Level 1 -->
  <div class="TreeView level1" *ngFor="let t1 of (ticketEditSrv.ticketArts | TreeViewChildren : true: ticketEditSrv.ticketArtSearchText)">
    <div *ngIf="ticketEditSrv.ticketArtSearchText == ''" class="treeview-item">
      <div class="heading" (click)="artClicked(t1)">
        <h3>{{t1.description}}</h3>
        <p *ngIf="t1.interval">Interval: {{t1.interval}}</p>
        <p *ngIf="t1?.toCalculate >= 0">Berechnen: {{t1.toCalculate | ToCalculateNameById}}</p>
      </div>
      
    </div>
    
    <!-- Level 2 -->
    <div class="TreeView level2" *ngFor="let t2 of (t1 | TreeViewChildren)">
      <div class="treeview-item">
        <div class="line"></div>
        <div class="heading"  (click)="artClicked(t2)">
          <h3>{{t2.description}}</h3>
          <p *ngIf="t2.interval">Interval: {{t2.interval}}</p>
          <p *ngIf="t2.toCalculate >= 0">Berechnen: {{t2.toCalculate | ToCalculateNameById}}</p>
        </div>
      </div>
      
      <!-- Level 3 -->
      <div class="TreeView level3" *ngFor="let t3 of (t2 | TreeViewChildren)">
        <div class="treeview-item">
          <div class="line"></div>
          <div class="line"></div>
          <div class="heading"  (click)="artClicked(t3)">
            <h3>{{t3.description}}</h3>
            <p *ngIf="t3?.toCalculate >= 0">Berechnen: {{t3.toCalculate | ToCalculateNameById}}</p>
          </div>
        </div>
        
        <!-- 2 Weitere Level -->

      </div>


    </div>
  </div>
</ion-content>



